import { useEffect, useState } from 'react';
import { IconButton, Link, Wordmark, navigate, useLocation } from '@dugzi/ui';
import { Menu, Search } from 'lucide-react';
import type { Me } from '../lib/types';
import { AccountMenu } from './AccountMenu';

/** On a phone the field is narrow: a short placeholder that fits (the label keeps the full name). */
function usePhone() {
  const q = '(max-width: 600px)';
  const [phone, setPhone] = useState(() => window.matchMedia(q).matches);
  useEffect(() => { const m = window.matchMedia(q); const on = () => setPhone(m.matches); m.addEventListener('change', on); return () => m.removeEventListener('change', on); }, []);
  return phone;
}

/** Brand, search (every field, as you type) and the account menu with the app launcher. */
export function TopBar({ me, onMenu, onMove }: { me: Me; onMenu(): void; onMove(t: 'import' | 'export' | 'sync'): void }) {
  const phone = usePhone();
  const { path, search } = useLocation();
  const [q, setQ] = useState(() => new URLSearchParams(search).get('q') ?? '');
  useEffect(() => { setQ(new URLSearchParams(search).get('q') ?? ''); }, [path]); // eslint-disable-line react-hooks/exhaustive-deps
  const go = (v: string) => {
    const p = new URLSearchParams(search);
    if (v.trim()) p.set('q', v); else p.delete('q');
    p.delete('p');
    const base = ['/birthdays', '/duplicates', '/trash', '/households'].includes(path) ? '/' : path;
    navigate(`${base}${p.toString() ? `?${p}` : ''}`, true);
  };
  return (
    <header className="top">
      <a className="dz-skip" href="#main">Skip to contacts</a>
      <IconButton className="top__menu" label="Address books and lists" icon={<Menu aria-hidden />} onClick={onMenu} />
      <Link to="/" className="top__brand" aria-label="Dugzi Contacts, all contacts"><Wordmark height={22} /><span className="top__label">Contacts</span></Link>
      <form className="search" role="search" onSubmit={(e) => { e.preventDefault(); go(q); }}>
        <Search aria-hidden size={18} />
        <input data-testid="search" type="search" placeholder={phone ? 'Search' : 'Search contacts'} aria-label="Search contacts" value={q}
          onChange={(e) => { setQ(e.target.value); go(e.target.value); }}
          onKeyDown={(e) => { if (e.key === 'Escape') { setQ(''); go(''); (e.target as HTMLInputElement).blur(); } }} />
      </form>
      <div className="top__actions"><AccountMenu me={me} onMove={onMove} /></div>
    </header>
  );
}
